
import React from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Calendar, Grid, Clock } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";

interface CalendarTabsProps {
  activeView: string;
  onViewChange: (view: string) => void;
}

export const CalendarTabs = ({
  activeView,
  onViewChange
}: CalendarTabsProps) => {
  const isMobile = useIsMobile();
  
  const handleTabClick = (value: string) => {
    console.log('Tab clicked:', value);
    onViewChange(value);
  };

  return (
    <ToggleGroup 
      type="single" 
      value={activeView} 
      onValueChange={handleTabClick} 
      className="mb-2 w-full"
    >
      <ToggleGroupItem 
        value="dayGridMonth" 
        className="flex-1 text-xs sm:text-sm py-1.5 px-2 font-medium data-[state=on]:bg-primary data-[state=on]:text-white"
      >
        <Calendar className="h-3.5 w-3.5 mr-1.5" />
        Month
      </ToggleGroupItem>
      <ToggleGroupItem 
        value="timeGridWeek" 
        className="flex-1 text-xs sm:text-sm py-1.5 px-2 font-medium data-[state=on]:bg-primary data-[state=on]:text-white"
      >
        <Grid className="h-3.5 w-3.5 mr-1.5" />
        Week
      </ToggleGroupItem>
      <ToggleGroupItem 
        value="timeGridDay" 
        className="flex-1 text-xs sm:text-sm py-1.5 px-2 font-medium data-[state=on]:bg-primary data-[state=on]:text-white"
      >
        <Clock className="h-3.5 w-3.5 mr-1.5" />
        Day
      </ToggleGroupItem>
    </ToggleGroup>
  );
};
